<script lang="ts">
export interface NavRailProps {
  expanded: boolean | 'responsive'
  expandedWidth?: number | string
  collapsedWidth?: number | string
  ariaLabel?: string
}
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { NAV_RAIL_COLLAPSED_WIDTH, NAV_RAIL_EXPANDED_WIDTH } from './constants'

const props = withDefaults(defineProps<NavRailProps>(), {
  expandedWidth: NAV_RAIL_EXPANDED_WIDTH,
  collapsedWidth: NAV_RAIL_COLLAPSED_WIDTH,
  ariaLabel: 'Navigation',
})

// Responsive width comes from classes, which must match the default widths.
const width = computed(() => {
  if (props.expanded === 'responsive') {
    return undefined
  }
  const value = props.expanded ? props.expandedWidth : props.collapsedWidth
  return typeof value === 'number' ? `${value}px` : value
})
</script>

<template>
  <div class="sticky top-0 z-sticky-app max-h-screen shrink-0 border-r border-gray-700 bg-brand-900 font-display">
    <nav
      class="flex h-full max-h-screen flex-col overflow-y-auto dark-scrollbar"
      :class="{ 'w-12.5 nav-expanded:w-57.5': expanded === 'responsive' }"
      :style="{ width }"
      :aria-label="ariaLabel"
    >
      <div v-if="'logo' in $slots" class="flex min-h-[80px] items-center justify-center border-b border-gray-700 px-4">
        <slot name="logo" />
      </div>
      <slot />
      <div v-if="'footer' in $slots" class="mt-auto border-t border-gray-700">
        <slot name="footer" />
      </div>
    </nav>
  </div>
</template>
